import { Download, BookOpen } from "lucide-react";
import { COLORING_PAGES, COLORING_BOOK_PDF, COLORING_BOOK_COVER, getCharacter } from "@/data/characters";
import { ChunkyButton } from "@/components/site/ChunkyButton";

const BookFeature = () => (
  <div data-testid="coloring-book-feature" className="mt-12 grid items-center gap-8 rounded-[2.5rem] bg-[#0b4fa3] p-6 text-white sm:p-10 md:grid-cols-[minmax(0,300px)_1fr]">
    <img src={COLORING_BOOK_COVER} alt="Handy & Friends Book 1 cover" className="mx-auto w-full max-w-[300px] -rotate-2 rounded-2xl bg-white shadow-2xl transition-transform duration-300 hover:rotate-0" />
    <div>
      <p className="font-display text-lg font-semibold text-[#ffe14d]">Book 1 · Ages 3–7 · 16 pages</p>
      <p className="mt-2 font-display text-3xl font-bold sm:text-4xl">The Great Clean-Hands Adventure</p>
      <p className="mt-3 max-w-xl text-sky-100">Read, color, play and wash with Handy, Soapy, Splashy and Germy. Learn the five clean-hands steps, solve the soap maze, count bubbles, and earn your Clean-Hands Helper certificate!</p>
      <ChunkyButton as="a" href={COLORING_BOOK_PDF} download data-testid="coloring-download-all-button" bg="#ffe14d" edge="#d4a600" color="#0b4fa3" className="mt-8">
        <BookOpen className="h-5 w-5" /> Download the Free Book
      </ChunkyButton>
    </div>
  </div>
);

export const ColoringSection = () => (
  <section id="color" data-testid="coloring-section" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-16 sm:px-8 sm:py-24">
    <div>
      <p className="font-display text-lg font-semibold text-[#1e9bf0]">Free printables</p>
      <h2 className="font-display text-4xl font-bold text-[#0b4fa3] sm:text-5xl">Color With Handy</h2>
      <p className="mt-3 max-w-lg text-slate-600">Print a page, grab your crayons, and bring Handy and friends to life.</p>
    </div>
    <BookFeature />
    <p className="mt-14 font-display text-2xl font-bold text-[#0b4fa3]">Or print just one friend:</p>
    <div className="mt-6 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
      {COLORING_PAGES.map((p, i) => {
        const c = getCharacter(p.slug);
        return (
          <div key={p.slug} data-testid={`coloring-card-${p.slug}`} className={`rounded-[2rem] border-4 bg-white p-4 shadow-[0_16px_40px_rgba(11,79,163,0.1)] transition-transform duration-300 hover:rotate-0 ${i % 2 ? "rotate-1" : "-rotate-1"}`} style={{ borderColor: c.theme.main }}>
            <img src={p.preview} alt={`${p.name} coloring page`} className="aspect-[3/4] w-full rounded-2xl object-contain" />
            <a href={p.pdf} download data-testid={`coloring-download-${p.slug}`}
              className="mt-4 flex min-h-[56px] items-center justify-center gap-2 rounded-full font-display text-lg font-semibold text-white transition-transform hover:scale-[1.03]" style={{ background: c.theme.deep }}>
              <Download className="h-5 w-5" /> {p.name} page
            </a>
          </div>
        );
      })}
    </div>
  </section>
);
